import React from "react";
/**
+ * Single chat message (label + bubble)
+ * role: "user" | "assistant"
+ * text: string
+ */
export default function ChatMessage({ role, text }) {
  const isUser = role === "user";
 const who = isUser ? "You" : "Assistant";
  return (
    <div className={`msg ${isUser ? "msg-user" : "msg-assistant"}`}>
      <div style={{ maxWidth: "100%" }}>
        <div className="meta">{who}</div>
        <div className="bubble">{text}</div>
      </div>
    </div>
  );
}